type BoxShadowSource = {
  ['box-shadow-x']?: Record<string, string>;
  ['box-shadow-y']?: Record<string, string>;
  ['box-shadow-blur']?: Record<string, string>;
  ['box-shadow-spread']?: Record<string, string>;
  ['box-shadow-color']?: Record<string, string>;
};

export const buildBoxShadow = (
  source: BoxShadowSource | undefined,
  state: string,
) =>
  `${source?.['box-shadow-x']?.[state] || '0px'} ${source?.['box-shadow-y']?.[state] || '0px'} ${source?.['box-shadow-blur']?.[state] || '0px'} ${source?.['box-shadow-spread']?.[state] || '2px'} ${source?.['box-shadow-color']?.[state] || 'transparent'}`;
